<template>
  <!-- 先看是不是子表单组件或分栏组件，再看是不是主表或者子表 -->
  <template v-if="isSubTable">
    <!-- 子表-子表单组件字段 -->
    <TableSubList
      :data="data"
      v-bind="$attrs"
      v-if="isSubListFlag"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />

    <!-- 主表-子表单组件字段 -->
    <SubList
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
  </template>

  <template v-else>
    <!-- 子表-分栏组件字段 -->
    <TableField
      v-if="isSubListFlag"
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />

    <!-- 主表-分栏组件字段 -->
    <SubField
      v-else
      :data="data"
      v-bind="$attrs"
      :formData="formData"
      :subFieldFormData="subFieldFormData"
    />
  </template>
</template>

<script lang="ts" setup>
import SubField from './subField.vue'
import SubList from './subList.vue'
import { PropType, computed } from 'vue'
import TableField from './tableField.vue'
import { isSubList } from '@/utils/preObjectManage/utils'
import TableSubList from './tableSubList.vue'
defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  isSubTable: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  data: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})
// 判断是否是子表字段
const isSubListFlag = computed(() => {
  return isSubList(props.data?.columnQuoteInfo?.quoteFieldType)
})
</script>
